import React, {useEffect, useState} from "react"
import {InputIconContainer, InputSearchContainer} from "../../components/ui/InputSearch";
import useDebounce from "../../hooks/useDebounce";
import {Clear} from "../../icon/Icon";
import {Input} from "../../components/ui/Content";

export interface InputSearchProps {
    onChange: (value: string) => void
    minLength?: number
    maxLength?: number
    required?: boolean
    placeholder?: string
}

export const InputSearch = ({onChange, minLength, maxLength, required, placeholder}: InputSearchProps): React.ReactElement => {

    const [inputValue, setInputValue] = useState<string>('')
    const debouncedSearchTerm = useDebounce(inputValue || '', 300);

    useEffect(() => {
        if (debouncedSearchTerm !== null && onChange) {
            onChange(debouncedSearchTerm)
        }
    }, [debouncedSearchTerm])

    return <InputSearchContainer>
        <Input
            minLength={minLength || 0}
            maxLength={maxLength || 999}
            required={required || false}
            autoFocus={true}
            placeholder={placeholder ?? 'Поиск'}
            value={inputValue}
            onChange={(e) => {
                setInputValue(e.target.value)
            }}/>
        {inputValue !== '' && <InputIconContainer onClick={() => {
            setInputValue('')
        }}>
            <Clear/>
        </InputIconContainer>}
    </InputSearchContainer>
}